import Vue from "vue";
import get from "lodash/get";
import { getEnvironment, getParameterByName } from "../../utils";

export default {
  enable() {},
  init() {},
  async enviar(context) {
    const environment = getEnvironment();
    const urlpostback =
      environment.name === "prod"
        ? "https://api.ar.alprestamo.io"
        : "https://sandbox.api.ar.alprestamo.io";
    const tracking_id = getParameterByName("tracking_id");
    const tipoPaquete = get(
      context,
      "state.paquetesBeneficios.caracteristicas.tipoPaquete",
      ""
    );

    if (tipoPaquete && tracking_id) {
      try {
        const response = await fetch(
          `${urlpostback}/bid/postback/only-by-url?tracking_id=${tracking_id}&status=granted&product=nomina`
        );
        await response.json();
      } catch (error) {
        Vue.$log.error(`AlPrestamo error`, error);
      }
    }
  }
};
